export const asNotificationOff = {
  data: `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 19.5C9.1 19.5 10 18.6 10 17.5H6C6 18.6 6.9 19.5 8 19.5ZM8 4C10.49 4 12 6.02 12 8.5V8.6L14 10.6V8.5C14 5.43 12.37 2.86 9.5 2.18V1.5C9.5 0.67 8.83 0 8 0C7.17 0 6.5 0.67 6.5 1.5V2.18C6.26 2.24 6.03 2.33 5.81 2.41L7.45 4.05C7.63 4.03 7.81 4 8 4ZM1.41 0.85L0 2.26L2.81 5.07C2.29 6.07 2 7.24 2 8.5V13.5L0 15.5V16.5H14.24L15.98 18.24L17.39 16.83L1.41 0.85ZM12 14.5H4V8.5C4 7.82 4.12 7.18 4.34 6.6L12 14.26V14.5Z" fill="currentColor"/>
</svg>

    `,
  name: 'notificationOff',
};
